import { createSelector } from "reselect";

const selectors = (state) => state.commonReducer;

const commonSelectors = createSelector(selectors, (state) => state);

export default commonSelectors;
